import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-web-desk-sidebar',
  templateUrl: './my-web-desk-sidebar.component.html',
  styleUrls: ['./my-web-desk-sidebar.component.css']
})
export class MyWebDeskSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
